enum DurationType {
  INTERVAL = "INTERVAL",
  DURATION = "DURATION",
}

export default DurationType;
